import { _getCategoria } from "../utils/helpers";

import { packageCode } from "@/config/constants/packagesCodes";
/**
 * Objeto principal de Google Remarketing
 */
export const GoogleRMKT = {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.src = "//www.googleadservices.com/pagead/conversion_async.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  init() {},
  wait() {
    return !!window.google_trackConversion;
  },
  enviar() {
    window.google_trackConversion({
      google_conversion_id: 793298531,
      google_custom_params: window.google_tag_params,
      google_remarketing_only: true
    });
  },
  landing() {
    window.google_tag_params = {
      Producto: "",
      Categoria: "Nominas OM",
      Pasos: "Landing"
    };
  },
  oferta(context) {
    window.google_tag_params = {
      Producto: _getCategoria(context.state.paquetesBeneficios.caracteristicas),
      Categoria: "Nominas OM",
      Pasos: "Oferta"
    };
  },
  ofertaCA() {
    window.google_tag_params = {
      Producto: "Caja de Ahorro",
      Categoria: "Nominas OM",
      Pasos: "Oferta"
    };
  },
  sucursal() {
    window.google_tag_params = {
      Producto: "Caja de Ahorro",
      Categoria: "Nominas OM",
      Pasos: "Paso 1"
    };
  },
  paso1(context) {
    window.google_tag_params = {
      Producto: _getCategoria(context.state.paquetesBeneficios.caracteristicas),
      Categoria: "Nominas OM",
      Pasos: "Paso 1"
    };
  },
  paso2(context) {
    window.google_tag_params = {
      Producto: _getCategoria(context.state.paquetesBeneficios.caracteristicas),
      Categoria: "Nominas OM",
      Pasos: "Paso 2"
    };
  },
  paso3(context) {
    window.google_tag_params = {
      Producto: _getCategoria(context.state.paquetesBeneficios.caracteristicas),
      Categoria: "Nominas OM",
      Pasos: "Paso 3"
    };
  },
  paso4(context) {
    window.google_tag_params = {
      Producto: _getCategoria(context.state.paquetesBeneficios.caracteristicas),
      Categoria: "Nominas OM",
      Pasos: "Paso 4"
    };
  },
  thankYou(context) {
    window.google_tag_params = {
      Producto: _getCategoria(context.state.paquetesBeneficios.caracteristicas),
      Categoria: "Nominas OM",
      Pasos: "Thank You"
    };
  },
  thankYouCA() {
    window.google_tag_params = {
      Producto: "Caja de Ahorro",
      Categoria: "Nominas OM",
      Pasos: "Thank You"
    };
  },
  cliente() {
    window.google_tag_params = {
      Producto: "CBU",
      Categoria: "Nominas OM",
      Pasos: "Thank You"
    };
  },
  noCliente() {
    window.google_tag_params = {
      Producto: "Sin oferta",
      Categoria: "Nominas OM",
      Pasos: "Thank You"
    };
  }
};

export const GoogleSiteTag = {
  enable() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = function() {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-793298531"; // NOSONAR
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },

  /**
   * Oferta Nomina
   */
  // Landing
  landing() {
    window.gtag("js", new Date());
    window.gtag("config", "AW-793298531/NDhvCLX9uKsBEOOMo_oC");
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/NDhvCLX9uKsBEOOMo_oC"
    });
  },

  /**
   * Pasos del Camino 1 - Caja de Ahorro
   */
  snippetOfertaCuenta() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/gKSPCMSOs5sZEOOMo_oC"
    });
  },
  snippetGraciasCajaAhorro() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/aSW3CJS2668DEK-clpcD"
    });
  },

  /**
   * Pasos del Camino 2 - Paquetes
   */
  snippetOferta() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/sZ6gCL6SuasBEOOMo_oC"
    });
  },
  snippetPaso1() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/tCySCM2VuasBEOOMo_oC"
    });
  },
  snippetPaso2() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/nrnzCMCUuasBEOOMo_oC"
    });
  },
  snippetPaso3() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/Q149CMLTwasBEOOMo_oC"
    });
  },
  snippetPaso4() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/Wk3_CIfUwasBEOOMo_oC"
    });
  },
  // TYP
  snippetThank(context) {
    let tipoPaquete =
      context.state.paquetesBeneficios.caracteristicas.tipoPaquete;
    let sendTo = {};

    switch (tipoPaquete) {
      case packageCode.LIBRETON_EXPRESS:
        sendTo = {
          send_to: "AW-793298531/SGHUCOaTuasBEOOMo_oC"
        };
        break;
      case packageCode.LIBRETON_FULL:
        sendTo = {
          send_to: "AW-793298531/NvB2CKCYuasBEOOMo_oC"
        };
        break;
      case packageCode.LIBRETON_PLUS_GOLD:
        sendTo = {
          send_to: "AW-793298531/RxZ2CImWuasBEOOMo_oC"
        };
        break;
      case packageCode.LIBRETON_PREMIUM:
        sendTo = {
          send_to: "AW-793298531/GacxCLmZuasBEOOMo_oC"
        };
        break;
      case packageCode.LIBRETON_PREMIUM_WORLD:
        sendTo = {
          send_to: "AW-793298531/G4jiCPCXuasBEOOMo_oC"
        };
        break;
    }

    window.gtag("event", "conversion", sendTo);
  },
  // Mensajes
  snippetSucursal() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/Sr3DCLP0p8wBEOOMo_oC"
    });
  },

  /**
   * Pasos del Camino 3 - Cliente
   */
  snippetCliente() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/GovMCLyamcwBEOOMo_oC"
    });
  },

  /**
   * Pasos del Camino 4 - No Cliente
   */
  snippetNoCliente() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/r9qXCNqE9NoBEOOMo_oC"
    });
  }
  /*
  snippetOfertaCA() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/cxTpCPmJtcwBEOOMo_oC"
    });
  },
  */
  /*
  snippetThankCA() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/XUZVCMGKtcwBEOOMo_oC"
    });
  },
  */
};

export const GoogleAds = {
  enable() {
    return true;
  },
  wait() {
    return !!window.gtag;
  },
  init() {
    window.gtag("js", new Date());
    window.gtag("config", "AW-793298531");
  },
  graciasCajaAhorro() {
    window.gtag("event", "conversion", {
      send_to: "AW-793298531/xFocCJqps5sZEOOMo_oC"
    });
  }
};
